import type React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../../../store/Index";
import { useSelector } from "react-redux";
import formatDate from "../../../../utils/FormatDate";

interface ForecastItem {
  date: string;
  event: string;
  location: string;
  time: string;
}

interface ForecastTableProps {
  data: ForecastItem[];
}

const ForecastTable: React.FC<ForecastTableProps> = ({ data }) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);
  const navigate = useNavigate();

  // Extracts the booking id from a title like "Booking 305"
  const extractBookingId = (eventTitle: string): string | null => {
    const match = eventTitle.match(/\bBooking\s+(\d+)\b/i);
    return match ? match[1] : null;
  };

  return (
    <Card sx={{ boxShadow: 0 }}>
      <CardHeader
        title={<Typography variant="h6">10-Day Forecast</Typography>}
      />

      <CardContent>
        <TableContainer sx={{ width: "100%" }}>
          <Table>
            <TableHead
              sx={{
                backgroundColor: reduxTheme.primary_colors?.[800] || "#E5BFA5",
              }}
            >
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Event</TableCell>
                <TableCell>Location</TableCell>
                <TableCell>Start Time</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data.slice(0, 5).map((shoot, index) => {
                const bookingId = extractBookingId(shoot.event);
                const isClickable = Boolean(bookingId);

                return (
                  <TableRow
                    key={index}
                    onClick={() => {
                      if (bookingId) {
                        navigate(`/bookings/${bookingId}`);
                      }
                    }}
                    sx={{
                      backgroundColor:
                        index % 2 === 0
                          ? "white"
                          : reduxTheme.primary_colors?.[800] || "#E5BFA5",
                      cursor: isClickable ? "pointer" : "default",
                      transition: "0.2s ease",
                      "&:hover": {
                        cursor: isClickable ? "pointer" : "default",
                        opacity: isClickable ? 0.85 : 1,
                      },
                    }}
                  >
                    <TableCell>{formatDate(shoot.date)}</TableCell>
                    <TableCell>{shoot.event}</TableCell>
                    <TableCell>{shoot.location}</TableCell>
                    <TableCell>{shoot.time}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default ForecastTable;
